import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
import { colorTokens } from '@eruvaka/web-pondlogs-base';
import { Preferences } from './settings/Preferences';
import { ProfileUsers } from './settings/ProfileUsers';
const TABS = [
    { key: 'preferences', labelKey: 'settings.preferences.title' },
    { key: 'profile-users', labelKey: 'settings.profileUsers.title' },
];
export const SettingsView = memo((props) => {
    const { t } = useTranslation('main');
    const { user: _user, initialSection = 'preferences', onProfilePhotoUpdated } = props;
    const [activeSection, setActiveSection] = useState(initialSection);
    const navigate = useNavigate();
    const handleSectionChange = (section) => {
        setActiveSection(section);
        navigate(`/settings/${section}`, { replace: true });
    };
    const renderContent = () => {
        switch (activeSection) {
            case 'preferences':
                return _jsx(Preferences, {});
            case 'profile-users':
                return _jsx(ProfileUsers, { onProfilePhotoUpdated: onProfilePhotoUpdated });
            default:
                return null;
        }
    };
    return (_jsxs(Box, { sx: {
            bgcolor: colorTokens.lightGrey,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        }, children: [_jsx(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    borderBottom: `1px solid ${colorTokens.borderLight}`,
                    bgcolor: colorTokens.lightGrey,
                    position: 'sticky',
                    top: 0,
                    zIndex: 5,
                }, children: TABS.map((tab) => {
                    const isActive = tab.key === activeSection;
                    return (_jsx(Box, { onClick: () => handleSectionChange(tab.key), sx: {
                            px: 2.5,
                            py: 1.5,
                            fontSize: 12,
                            fontWeight: 700,
                            letterSpacing: '0.01em',
                            cursor: 'pointer',
                            color: isActive ? colorTokens.primary : colorTokens.darkGrey,
                            position: 'relative',
                            whiteSpace: 'nowrap',
                            userSelect: 'none',
                            transition: 'color 0.15s',
                            '&:hover': { color: colorTokens.primary },
                            '&::after': isActive
                                ? {
                                    content: '""',
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    height: '2px',
                                    bgcolor: colorTokens.magenta,
                                    borderRadius: '2px 2px 0 0',
                                }
                                : {},
                        }, children: t(tab.labelKey) }, tab.key));
                }) }), _jsx(Box, { sx: {
                    flex: 1,
                    p: { xs: 2, md: 2.5 },
                    overflow: 'hidden',
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                }, children: renderContent() })] }));
});
SettingsView.displayName = 'SettingsView';
